import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-sales-policy-disclaimer',
    templateUrl: './sales-policy-disclaimer.component.html',
    styleUrls: ['./sales-policy-disclaimer.component.scss'],
    standalone: false
})
export class SalesPolicyDisclaimerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
